import React, { Component, PropTypes as T } from 'react';
import moment from 'moment';
import { TransitionMotion, spring, presets } from 'react-motion';
import { Button, Icon } from 'b3';
import './datepicker.less';
import { OutsideClickHandler } from 'b3';
import Anchor from 'b3/anchor/Anchor';
import makeDatesForMonth from './makeDatesForMonth';

export default class DatePicker extends Component {
    static defaultProps = {
		onPickDate: () => {},
        onCancel: () => {},
        onFocus: () => {},
        onSubmit: null,
        closeOnOutsideClick: true,
        weekOffset: 0,
        height: 200,
        target: null
    };

    static propTypes = {
        onSubmit: T.func,
        onCancel: T.func.isRequired
    };
    
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
            direction: 'left',
            date: props.date.isValid() ? props.date : moment(),
        };
    }

    componentWillUpdate(nextProps) {
        if(this.props.date != nextProps.date) {
            this.state.date = nextProps.date.isValid() ? nextProps.date : moment();
        }
    }

    changeMonth(delta, e) {
        e.preventDefault();
        this.setState({
            date: this.state.date.add(delta, 'months'),
            direction: delta < 0 ? 'left' : 'right'
        });
    }

    scrollToToday() {
        var date = moment();
        this.setState({ date });
        this.props.onPickDate(date);
    }

    onPickDate(date) {
        var deltaMonths = date.month() - this.state.date.month();
		this.props.onPickDate(date);
        this.setState({
            date,
            direction: deltaMonths < 0 ? 'left' : 'right'
        });
    }
    
    handleOnMouseDown(e) {
        this.props.onFocus(e);
    }

    handleOnSubmit(e) {
        e.preventDefault();
        this.props.onSubmit(this.state.date);
    }

    handleOnCancel(e) {
        if(this.props.closeOnOutsideClick) {
            e.preventDefault();
            this.props.onCancel();
        }
    }
    render() {
        var { date, direction } = this.state;
        var { weekOffset, height }  = this.props;

        var component = (
              <div className="inner-wrapper">
                  <div className="month-header">
                      <div className="change-month-button" onClick={this.changeMonth.bind(this, -1)}><Icon icon="arrow-circle-29" /></div>
                      <div className="header-current-date">{date.format('MMMM')}</div>
                      <div className="change-month-button" onClick={this.changeMonth.bind(this, 1)}><Icon icon="arrow-circle-30" /></div>
                  </div>
                  <div className="calendar-grid-header">
                      <div className="calendar-grid-header-item">S</div>
                      <div className="calendar-grid-header-item">M</div>
                      <div className="calendar-grid-header-item">T</div>
                      <div className="calendar-grid-header-item">W</div>
                      <div className="calendar-grid-header-item">T</div>
                      <div className="calendar-grid-header-item">F</div>
                      <div className="calendar-grid-header-item">S</div>
                  </div>
                  <div key={this.state.date.format('YYYY-MM-DD')} style={{height}} className="calendar-grid">
                      {makeDatesForMonth(date, weekOffset).map((day, i) => 
                          <Day 
                              key={`day-${day.day.format('YYYY-MM-DD')}`} 
                              onPickDate={this.onPickDate.bind(this)}
                              selectedDate={date}
                              day={day} />
                      )}
                  </div>
              </div>
        );

        var item = {id: date.format('YYYY-MM'), direction, component, width: 300, height};
        
        return (
            <Anchor target={this.props.target} align={this.props.align ? this.props.align : "center"} position={this.props.position ? this.props.position : "top"}>
                <div ref="datepicker" className="b3-date-picker" onMouseDown={this.handleOnMouseDown.bind(this)}>
                    <OutsideClickHandler onOutsideClick={this.handleOnCancel.bind(this)}>
                        <div style={{display: 'flex', flexDirection: 'column', background: '#fff'}}>
                            <div className="date-preview">
                                <DateSlider text={date.format('ddd, MMM D')} date={date} />
                            </div>
                            <SlideWrapper item={item}></SlideWrapper>
                            <div className="date-picker-actions">
                                <div className="button-container"><Button type="default" block onClick={this.scrollToToday.bind(this)}>Today</Button></div>
                                { this.props.onSubmit && 
                                    <div className="button-container"><Button type="primary" block onClick={this.handleOnSubmit.bind(this)}>Ok</Button></div>
                                }
                            </div>
                        </div>
                    </OutsideClickHandler>
                </div>
            </Anchor>
        );
    }
}

class Day extends Component {
    onPickDate(e) {
        this.props.onPickDate(this.props.day.day);
    }
    render() {
        var {day, selectedDate} = this.props;
        var isSelected = selectedDate.isSame(day.day, 'day');
        var classNames = `calendar-grid-item ${day.classNames} ${isSelected ? "selected" : ""}`;

        return (
            <div
                key={`day-${day.day.format('YYYY-MM-DD')}`}
                className={classNames}
                onClick={this.onPickDate.bind(this)}>
                {day.day.format('DD')}
            </div>
        );
    }
}

export function Slide({slide}) {
    
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: slide.data.height,
        opacity: slide.style.opacity,
        transform: `translateX(${slide.style.x}px)`,
      }}>
      {slide.data.component}
    </div>
  );
}

export function SlideWrapper({item}) {
    var {direction, width} = item;
    var leaveX = direction == 'right' ? -width : width;
    var enterX = direction == 'right' ? width : -width;

    var itemStyles = [{
        key: item.id,
        data: item,
        style: {
            opacity: spring(1),
            x: spring(0, presets.noWobble),
        }
    }];

    var willEnterFunc = () => ({
        opacity: 0,
        x: enterX
    });

    var willLeaveFunc = () => {
        // triggered when c's gone. Keeping c until its width/height reach 0.
        return {
            // leaving: true,
            opacity: spring(0),
            x: spring(leaveX, presets.noWobble)
        };
    }

    var innerStyle = { position: 'relative' };

    return (
        <TransitionMotion styles={itemStyles} willLeave={willLeaveFunc} willEnter={willEnterFunc}>
            {interPolatedStyles =>
                <div style={innerStyle}>
                    {interPolatedStyles.map(config => {
                            return (<Slide key={config.key} slide={config} />)
                        })
                    }
                </div>
            }
        </TransitionMotion>
      );
}

export class DateSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            item: { id: props.text, text: props.text, direction: 'up', height: 15 }
        };
    }
    componentWillReceiveProps(nextProps) {
        var isLater = nextProps.date.diff(this.state.date) >= 0;

        this.setState({
            date: nextProps.date,
            item: { id: nextProps.text, text: nextProps.text },
            direction: isLater ? 'up' : 'down',
            height: 15
        });
    }
    render() {
        return (
            <VerticalSlider item={this.state.item} />
        );
    }
}

function VerticalSlider({item}) {
    var itemStyles = [{
        key: item.id,
        data: item,
        style: {
            opacity: spring(1),
            y: spring(0),  
        }
    }];

    var innerStyle = {
        position: 'relative',
        padding: '20px 0',
        fontFamily: 'sans-serif',
        fontSize: 25,
        textAlign: 'center',
    };

    return (
        <TransitionMotion styles={itemStyles}>
            {interPolatedStyles =>
                <div style={innerStyle}>
                    {interPolatedStyles.map(config => {
                        return (
                            <div key={config.key}
                              style={{
                                width: '100%',
                                position: config.leaving ? 'absolute' : 'static',
                                opacity: config.style.opacity,
                                transform: `translateY(${config.style.y}px)`,
                              }}>
                              {config.data.text}
                            </div>
                        )}
                    )}
                </div>  
            }
        </TransitionMotion>
    );
}



// WEBPACK FOOTER //
// ./app/b3/date-picker/DatePicker.js